module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/node-libs-browser/~/readable-stream/~/isarray/index.js
 ** module id = 361
 ** module chunks = 0
 **/